import ExamSourceMixin from '@/shared/mixins/exam-source.mixin'
import support from '@/components/support/index.vue'
import billing from '@/components/billing/index.vue'
import AuthMixin from '@/shared/mixins/auth.mixin'
import routes from '@/router/routes'
import svgWifiIcon from '../../assets/svg/wifi-logo.svg'
import svgWifiOffIcon from '../../assets/svg/wifi-off.svg'
import { mapGetters, mapActions } from 'vuex'
import finantialAlert from '@/components/finantial-alert/index.vue'
import debugCapture from '@/components/debug-capture/index.vue'
import CONSTANTS from '@/shared/constants/constants'
import ReviewReportMixin from '@/shared/mixins/review-report.mixin'
import {
  getHeaderLogoPath,
  isPiauiHostname,
  isAmazonasHostname,
  isAlagoasHostname,
  isAmapaHostname,
  isPortalHostname
} from '@/shared/utils/hostname'

export default {
  name: 'utilities',
  components: {
    billing,
    support,
    finantialAlert,
    debugCapture
  },
  mixins: [ExamSourceMixin, AuthMixin, ReviewReportMixin],
  data() {
    return {
      logo: getHeaderLogoPath(),
      userLogo: null,
      userName: '',
      showNavbar: false,
      showBilling: false,
      periodItems: [],
      showLoadingModal: false,
      messageLoadingModal: this.$i18n.t('loading.default'),
      showLoadingBar: false,
      showBlockPage: false,
      messageBlockPage: this.$i18n.t('tab.extra_tabs_open'),
      user: {},
      oldTab: null,
      connectionInterval: null,
      connectionAlert: false,
      connectionOffAlert: false,
      connectionTooltip: this.$i18n.t('connectionTooltip'),
      wifiIcon: svgWifiIcon,
      wifiOffIcon: svgWifiOffIcon,
      userProfile: '',
      sources: [],
      selectedSource: null,
      reviewer: false,
      menu: [],
      hasFinancialAccess: false,
      canViewDicomPlus: false,
      sourcePage: 1,
      sourcePageSize: 50,
      sourceHasMore: true,
      sourceListLoading: false,
      searchSource: '',
      searchApplied: '',
      searchLoading: false,
      isNavDrawerOpen: false,
      viewportWidth: window.innerWidth,
      languages: (this.$i18n && this.$i18n.availableLocales) ? this.$i18n.availableLocales : ['pt-BR', 'en-US'],
      currentLanguage: (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : 'pt-BR',
      helpOpen: false
    }
  },
  computed: {
    tab () {
      const endpoint = this.$route.path
      return endpoint
    },
    canSeeBilling () {
      return this.isSource() && this.hasFinancialAccess
    },
    visibleSources () {
      const term = (this.searchApplied || '').toLowerCase()
      if (!this.showSourceSearch || !term) return this.sources
      return this.sources.filter(s => (s.value || '').toLowerCase().includes(term))
    },
    showSourceSearch () {
      return (this.sources?.length || 0) >= 6 || !!(this.searchApplied || '').trim()
    },
    isCompactNavbar () {
      return this.viewportWidth <= 1420
    }
  },
  async beforeMount() {
    await this.setReviewer()
  },
  async mounted () {
    const isAuthenticated = this.isAuthenticated()

    if (isAuthenticated) {
      await this.initSelectSources()
    }

    this.$socket.connect()
    await this.showUtilities()
    this.$root.$on('showNavbarLoading', () => {
      this.showLoadingBar = true
    })
    this.$root.$on('hideNavbarLoading', () => {
      this.showLoadingBar = false
    })
    this.$root.$on('showLoading', (message) => {
      this.showLoadingModal = true
      this.messageLoadingModal = message ||
        this.$i18n.t('loading.default')
    })
    this.$root.$on('hideLoading', () => {
      this.showLoadingModal = false
    })
    this.connectionInterval = setInterval(() => {
      !navigator.onLine ? this.connectionOffAlert = true : this.connectionOffAlert = false
      if (navigator.connection) {
        const connectionQuality = navigator.connection.downlink
        connectionQuality <= 4 && navigator.onLine ? this.connectionAlert = true : this.connectionAlert = false
      }
    }, 15000)
  },
  beforeDestroy () {
    clearInterval(this.connectionInterval)
  },
  methods: {
    ...mapGetters([
      'getCurrentTab'
    ]),
    ...mapActions([
      'setCurrentTab'
    ]),
    showSourceSelector() {
      return this.isFonte() && (this.sources?.length > 0 || !!(this.searchApplied || '').trim())
    },
    hasMultipleSources () {
      return this.sources?.length > 1
    },
    initSelectSources () {
      return new Promise(async (resolve, reject) => {
        try {
          this.sources = []
          this.sourcePage = 1
          this.sourceHasMore = true

          const savedSource = JSON.parse(localStorage.getItem("selectedSource") || "null")
          const pageItems = await this.getCurrentUserSourcesWithFilters({
            page: this.sourcePage,
            pageSize: this.sourcePageSize,
            name: (this.searchApplied || '').trim()
          })

          const mapped = (pageItems || []).map((s) => ({ ...s, value: s.description }))

          this.sources = mapped
          this.sourceHasMore = mapped.length === this.sourcePageSize

          const role = this.getFirstRole()
          if (role !== "source") {
            localStorage.removeItem("selectedSource")
            this.selectedSource = null
            resolve(this.sources)
            return
          }

          if (savedSource?.id) {
            let matchedSource = this.sources.find(s => s.id === savedSource.id)
            if (!matchedSource && this.sourceHasMore) {
              matchedSource = await this.findSourceAcrossPages(savedSource.id)
            }
            this.selectedSource = matchedSource || savedSource || this.sources[0] || null
            localStorage.setItem("selectedSource", JSON.stringify(this.selectedSource))
          } else {
            this.selectedSource = this.sources[0] || null
            if (this.selectedSource) {
              localStorage.setItem("selectedSource", JSON.stringify(this.selectedSource))
            }
          }

          resolve(this.sources)
        } catch (error) {
          reject(error)
        }
      })
    },
    async findSourceAcrossPages(targetSourceId) {
      let currentPage = 2
      let hasMorePages = this.sourceHasMore

      while (hasMorePages) {
        const pageSources = await this.getCurrentUserSourcesWithFilters({
          page: currentPage,
          pageSize: this.sourcePageSize,
          name: (this.searchApplied || '').trim()
        })
        const formattedList = (pageSources || []).map(source => ({
          ...source,
          value: source.description
        }))
        this.sources = [...this.sources, ...formattedList]

        const matchedSource = formattedList.find(source => source.id === targetSourceId)
        if (matchedSource) return matchedSource

        hasMorePages = formattedList.length === this.sourcePageSize
        currentPage += 1
      }
      return null
    },
    async fetchSourcesPage ({ page, name } = {}) {
      if (this.sourceListLoading) return
      this.sourceListLoading = true
      try {
        const currentPage = page || this.sourcePage
        const searchTerm = (name ?? this.searchApplied ?? '').trim()

        const sources = await this.getCurrentUserSourcesWithFilters({
          page: currentPage,
          pageSize: this.sourcePageSize,
          name: searchTerm
        })

        const sourceList = (sources || []).map(s => ({ ...s, value: s.description }))

        if (currentPage === 1) {
          this.sources = sourceList
        } else {
          this.sources = [...this.sources, ...sourceList]
        }

        this.sourceHasMore = sourceList.length === this.sourcePageSize
      } finally {
        this.sourceListLoading = false
      }
    },
    onSourcesScroll () {
      const list = this.$refs.sourcesList
      if (!list) return
      if (this.sourceListLoading || !this.sourceHasMore) return

      const reachedEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 12
      if (reachedEnd) {
        this.loadNextSourcesPage()
      }
    },
    async loadNextSourcesPage () {
      if (this.sourceListLoading || !this.sourceHasMore) return
      this.sourcePage += 1
      await this.fetchSourcesPage({ page: this.sourcePage })
    },
    applySourceFilter () {
      this.searchLoading = true
      try {
        const term = (this.searchSource || '').trim()
        this.searchApplied = term
        this.sourcePage = 1
        this.sourceHasMore = true

        this.$nextTick(() => {
          const list = this.$refs.sourcesList
          if (list) {
            list.scrollTop = 0
            if (typeof list.focus === 'function') list.focus()
          }
        })

        this.fetchSourcesPage({ page: 1, name: term })
      } finally {
        this.searchLoading = false
      }
    },
    clearSearch () {
      const hadFilter = !!(this.searchApplied || '').trim()
      this.searchSource = ''
      this.searchApplied = ''

      this.$nextTick(() => {
        const list = this.$refs.sourcesList
        if (list) list.scrollTop = 0
      })

      if (hadFilter) {
        this.sourcePage = 1
        this.sourceHasMore = true
        this.fetchSourcesPage({ page: 1, name: '' })
      }
    },
    async changeSource (source) {
      this.selectedSource = source
      localStorage.setItem("selectedSource", JSON.stringify(source))
      // TODO: check this comment
      // this.$root.$emit('selectSource')
      if (this.isFonte() && source?.id) {
        this.userLogo = await this.getLogoUser()
      }
      const allowedRoutes = ['exames']
      if (this.canViewDicomPlus) allowedRoutes.push('dicom-plus')
      if (source?.xplus === true || source?.criarExameXPlus === true) allowedRoutes.push('tracado-plus')
      const currentRoute = this.$router.currentRoute.name

      if (!allowedRoutes.includes(currentRoute)) {
        this.$router.push({ name: 'exames' });
      } else {
        this.$router.go();
      }
    },
    async showUtilities () {
      const routeName = this.$router.currentRoute.name
      if (/login/.test(routeName)) {
        this.hideUtilities()
        return
      }

      if (!this.isAuthenticated()) {
        return
      }
      this.user = this.getUser()
      this.hasFinancialAccess = this.user.financialAccess
      this.canViewDicomPlus = this.user?.viewDicomPlus === true
      this.userName = this.user.userName
      this.userProfile = this.user.role.name
      this.showNavbar = true
      // this.onConnected(this.user)

      this.userLogo = null
      if (this.isFonte()) {
        if (!this.selectedSource) {
          await this.initSelectSources()
        }
        // Reconstrói o menu agora que a fonte está carregada. A aba Traçado Plus depende da
        // flag xplus da fonte, indisponível quando o menu é montado no beforeMount (ex.: 1º login).
        this.menu = this.buildMenu()
        this.userLogo = await this.getLogoUser()

        const key = import.meta.env.VITE_SUBSCRIPTION_APPLICATION_SERVER_KEY
        await navigator.serviceWorker.register('./sw.js')
        const sw = await navigator.serviceWorker.ready
        const subscription = await sw.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: key
        })
        await this.addSubscription(subscription)
      }
    },
    hideUtilities () {
      this.showNavbar = false
    },
    getLogoUser () {
      try {
        return this.getExamSourceLogo()
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    getLogoByURL () {
      return getHeaderLogoPath()
    },
    isPiauiDomain () {
      return isPiauiHostname()
    },
    isAmazonasDomain () {
      return isAmazonasHostname()
    },
    isAlagoasDomain () {
      return isAlagoasHostname()
    },
    isAmapaDomain () {
      return isAmapaHostname()
    },
    isPortalDomain () {
      return isPortalHostname()
    },
    logout () {
      this.logoutUser()
      localStorage.removeItem('pendencyAlertDismissed')
    },
    isSource () {
      return this.user.role.name === 'source'
    },
    isPhysician () {
      return this.getFirstRole && this.getFirstRole() === CONSTANTS.ROLES.PHYSICIAN
    },
    issueBill () {
      window.open('https://telemedicinaportalcliente.cigam.cloud/logincontato', '_blank')
    },
    billing () {
      this.showBilling = true
    },
    buildMenu() {
      const role = this.getFirstRole()
      const user = this.getUser()
      const physician = user?.physician || {}
      const isPhysician = role === CONSTANTS.ROLES.PHYSICIAN
      const isSource = role === CONSTANTS.ROLES.SOURCE
      const isOnlyReports = physician?.onlyReports === true
      const isListExams = physician?.listExams === true
      const isReviewer = this.reviewer

      if (isPhysician && !isOnlyReports && !isListExams && !isReviewer) {
        this.$root.$emit('toast', { message: this.$t('no-physician-function'), type: 'warning' })
        this.logoutUser()
        return []
      }

      if (isSource) {
        this.canViewDicomPlus = user?.viewDicomPlus === true
        let selectedSource = this.selectedSource
        if (!selectedSource) {
          try {
            selectedSource = JSON.parse(localStorage.getItem('selectedSource') || 'null')
          } catch (e) {
            selectedSource = null
          }
        }
        const sourceMenuPaths = ['/exames']
        if (this.canViewDicomPlus) sourceMenuPaths.push('/dicomplus')
        if (selectedSource?.xplus === true || selectedSource?.criarExameXPlus === true) sourceMenuPaths.push('/tracadoplus')
        const sourceMenus = routes
          .filter(item => item.meta.roles && item.meta.roles.includes(role) && item.menu)
          .filter(item => sourceMenuPaths.includes(item.path))
          .map(item => ({
            label: item?.menu?.name,
            route: item.path,
            isActive: this.$route.path === item.path
          }))
        return sourceMenus
      }

      const optionsRoutes = routes
        .filter((item) => item.meta.roles && item.meta.roles.includes(role) && item.menu)
        .filter((item) => {
          if (!isPhysician && item.meta.roles && !item.meta.roles.includes(role) && item.menu) {
            return true
          }
          if (!isOnlyReports && !isListExams && !isReviewer) {
            return true
          }
          if (
            !['/medico/laudar', '/medico/laudar-radio', '/medico/revisar-laudo'].includes(item.path) &&
            (isOnlyReports || isListExams || isReviewer)
          ) {
            return false
          }
          if (item.path === '/medico/laudar') return isOnlyReports
          if (item.path === '/medico/laudar-radio') return isListExams
          if (item.path === '/medico/revisar-laudo') return isReviewer
          return true
        })
        .filter(
          (item) =>
            item.path === '/medico/laudar' ||
            item.path === '/medico/laudar-radio' ||
            item.path === '/medico/revisar-laudo')
        .map((item) => ({
          label: item?.menu?.name,
          route: item.path,
          isActive: this.$route.path === item.path
        }))

      return optionsRoutes
    },
    updateMenuActive () {
      const currentPath = this.$route?.path
      this.menu = (this.menu || []).map(item => ({
        ...item,
        isActive: item.route === currentPath
      }))
    },
    async setReviewer() {
      const role = this.getFirstRole()
      const isPhysician = role === CONSTANTS.ROLES.PHYSICIAN
      if (isPhysician) {
        const response = await this.getPhysicianDisplayOptions()
        this.reviewer = response?.reviewer
        sessionStorage.setItem('isReviewer', this.reviewer)
      }
      this.menu = this.buildMenu()
    },
    openNavDrawer () {
      this.isNavDrawerOpen = !this.isNavDrawerOpen
      document.body.classList.toggle('nav-drawer-open', this.isNavDrawerOpen)
    },
    closeNavDrawer () {
      this.isNavDrawerOpen = false
      document.body.classList.remove('nav-drawer-open')
    },
    handleNavItem (item) {
      if (item?.route) {
        this.$router.push(item.route)
      }
      this.closeNavDrawer()
    },
    drawerLogout () {
      this.logout()
      this.closeNavDrawer()
    },
    drawerBilling () {
      this.closeNavDrawer()
      setTimeout(() => {
        this.showBilling = true
      }, 260)
    },
    drawerIssueBill () {
      this.issueBill()
      this.closeNavDrawer()
    },
    drawerChangeSource (sourceOrId) {
      const sourceId = sourceOrId?.id || sourceOrId
      const found = this.sources.find(s => s.id === sourceId)
      if (found) {
        this.changeSource(found)
      }
      this.closeNavDrawer()
    },
    openHelpLink (url) {
      if (url) window.open(url, '_blank')
      this.closeNavDrawer()
    },
    changeLanguage (lang) {
      if (!lang || !this.$i18n) return
      this.$i18n.locale = lang
      this.currentLanguage = lang
      localStorage.setItem('app-language', lang)
      this.closeNavDrawer()
    }
  },
  watch: {
    $route: function (to, from) {
      if (/login/.test(to.name)) {
        this.hideUtilities()
      }

      if (/login/.test(from.name)) {
        this.showUtilities()
      }

      if (/medico\/laudar/.test(to.name)) {
        this.setCurrentTab(to.name)
      }
      this.updateMenuActive()
    },
    showSourceSearch (enabled) {
      if (!enabled && !this.searchApplied) {
        this.clearSearch()
      }
    }
  }
}
